import React, { Component } from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { IntlProvider, FormattedMessage } from 'react-intl';

import StaticForm from './StaticQRForm';
import api from '../api';
import { genPayData2, isWexin } from '../utils';

import Footer from '../components/SupportbyFooter';

import { locale, messages, localizedText } from '../i18n';

const WalletName = styled.div`
  color: #47474;
  text-align: center;
  padding: 1em 0;
  font-size: 1.7em;
  min-height: 90px;
`;

const REACT_APP_ROOT_URL = process.env.REACT_APP_ROOT_URL || '';

const walletIdsReferenceRequired = [
  'W000000174',
  'W000002713',
  'W000002716',
  'W000005181',
  'W000004349',
  'W000004348',
  'W000004347',
  'W000000330',
  'W000000319',
  'W000000318',
  'W000000317',
  'W000000316',
  'W000000315',
  'W000000314',
  'W000000313',
  'W000000312',
  'W000000311',
  'W000000310',
  'W000000270',
  'W000000269',
  'W000005525',
  'W000005345',
  'W000005777',
  'W000008207',
  'W000005178',
  'W000008153',
  'W000008226',
  'W000008510',
  'W000008496',
  'W000010776',
  'W000000495',
  'W000002480',
  'W000031780',
  'W000031777',
  'W000031775',
  'W000031774',
  'W000026589',
  'W000019693',
  'W000019713',
  'W000019716',
  'W000032525',
  'W000001200',
  'W000011570',
  'W000005777',
  'W000016991',
  'W000033949',
  'W000036430',
  'W000036437',
  'W000007990',
  'W000037930',
  'W000037931',
  'W000037932',
  'W000041330',
  'W000041329',
  'W000041328',
  'W000041327',
  'W000041326',
  'W000041325',
  'W000041391',
  'W000041716',
  'W000041717',
  'W000042050',
  'W000043252',
  'W000043478',
  'W000031016',
  'W000031014',
  'W000030901',
  'W000043959',
  'W000043960',
  'W000043961',
  'W000043962',
  'W000043963',
  'W000043964',
  'W000043965',
  'W000043966',
  'W000043967',
  'W000043968',
  'W000043969',
  'W000043970',
  'W000032339'
];

function placeholder(walletId, props) {
  const map = {
    W000005525: localizedText('staticqr.reference.placeholder.code'),
    W000005345: localizedText('staticqr.reference.placeholder.invoice'),
    W000008207: 'Last name and invoice number',
    W000005178: 'Last name and invoice number',
    W000008153: 'Please input your name',
    W000008226: 'Input name and phone number',
    W000008510: '填写学生姓名和invoice号码',
    W000008496: '填写学生姓名和invoice号码',
    W000010776: '请填写A开头的客户号',
    W000000495: '请填写英文姓名和手机号',
    W000002480: '请填写名字和电话',
    W000031780: 'Description/Tenant Code(9 digital code)',
    W000031777: 'Description/Tenant Code(9 digital code)',
    W000031775: 'Description/Tenant Code(9 digital code)',
    W000031774: 'Description/Tenant Code(9 digital code)',
    W000026589: 'Description/Tenant Code(9 digital code)',
    W000019693: 'Full Name&Room Number',
    W000019713: 'Full Name&Room Number',
    W000019716: 'Full Name&Room Number',
    W000032525: 'Full Name&Room Number',
    W000001200: '群名/客户名称+日期',
    W000011570: '群名/客户名称+日期',
    W000005777: '请填写会员号或电话',
    W000016991: 'Full Name',
    W000033949: '请填写姓名和电话号码',
    W000036430: '请填写姓名和invoice number',
    W000036437: '请填写姓名和invoice number',
    W000007990: '请填写会员号或电话',
    W000037930: '订单号(6位)+姓名+地址+电话',
    W000037931: '订单号(6位)+姓名+地址+电话',
    W000037932: '订单号(6位)+姓名+地址+电话',
    W000041330: '请填写手机号和名字',
    W000041329: '请填写手机号和名字',
    W000041328: '请填写手机号和名字',
    W000041327: '请填写手机号和名字',
    W000041326: '请填写手机号和名字',
    W000041325: '请填写手机号和名字',
    W000041391: '请填写手机号和名字',
    W000041716: '请填写手机号和名字',
    W000041717: '请填写手机号和名字',
    W000042050: ' ',
    W000043478: '请标注学员姓名',
    W000031016: '请填写姓名和student ID',
    W000031014: '请填写姓名和student ID',
    W000030901: '请填写姓名和student ID',
    W000043959: 'Car brand & client name',
    W000043960: 'Car brand & client name',
    W000043961: 'Car brand & client name',
    W000043962: 'Car brand & client name',
    W000043963: 'Car brand & client name',
    W000043964: 'Car brand & client name',
    W000043965: 'Car brand & client name',
    W000043966: 'Car brand & client name',
    W000043967: 'Car brand & client name',
    W000043968: 'Car brand & client name',
    W000043969: 'Car brand & client name',
    W000043970: 'Car brand & client name',
    W000032339: '请输入您的电子邮箱'
  };

  const text = map[walletId];
  if (text) {
    return text;
  }

  return checkReferenceRequired(walletId, props)
    ? localizedText('staticqr.reference.placeholder.required')
    : localizedText('staticqr.reference.placeholder');
}

function checkReferenceRequired(wallet_id, props) {
  const need_reference = (props.location || {}).search || '';
  return (
    walletIdsReferenceRequired.indexOf(wallet_id) !== -1 ||
    need_reference.indexOf('need_reference=1') !== -1
  );
}

class StaticQR extends Component {
  constructor(props) {
    super(props);

    const { search } = props.location || {};
    const params = new URLSearchParams(search);

    const isMoneyMore = params.get('isMoneyMore');
    const payCurrency = params.get('pay_currency');
    if (payCurrency) {
      this.state.currencyInQuery = payCurrency;
    }

    this.loading = false;
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      isPaying: false,
      error: false,
      data: {
        accountName: localizedText('staticqr.loading')
      },
      isPayAlipay: false,
      isMoneyMore
    };
  }
  async componentDidMount() {
    const { isMoneyMore } = this.state;
    const { wallet_id, user_id } = this.props.match.params;
    if (isMoneyMore) {
      window.location.href = `https://m${
        window.location.href.indexOf('-staging') !== -1 ? '-staging' : ''
      }.latipay.net`;
      return;
    }

    this.setState({
      loadingWallet: true
    });

    let walletData1;
    try {
      //TODO
      const { data: walletData } = await api.staticQR.getWalletInfoByUserId(
        user_id,
        wallet_id
      );
      walletData1 = walletData;
    } catch (e) {}

    if (
      walletData1 &&
      walletData1.code === 0 &&
      walletData1.organisationCode &&
      walletData1.shortCode
    ) {
      //TODO
      window.location = `${window.location.origin}${REACT_APP_ROOT_URL}/${
        walletData1.organisationCode
      }/${walletData1.shortCode}`;
      return;
    } else {
      this.setState({
        loadingWallet: false
      });
    }

    const { data } = await api.staticQR.get(
      isWexin ? 'wechat' : 'alipay',
      user_id,
      wallet_id
    );

    if (data.data) {
      this.setState({
        data: data.data
      });
    } else if (data.code) {
      this.setState({
        error: true
      });
    }
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  async onSubmit(form) {
    const value = numeral(form.amount).value();
    if (!this.isNumeric(value)) {
      alert(localizedText('staticqr.number'));
      return;
    }

    if (value <= 0) {
      alert(localizedText('staticqr.minimum'));
      return;
    } else if (value >= 1000000) {
      alert(localizedText('staticqr.maxmum'));
      return;
    }

    // if (form.reference && form.reference.length > 50) {
    //   alert(localizedText('staticqr.reftoolong'));
    //   return;
    // }

    const { wallet_id, user_id } = this.props.match.params;

    if (
      checkReferenceRequired(wallet_id, this.props) &&
      (!form.reference || form.reference === '')
    ) {
      alert(localizedText('staticqr.need_reference'));
      return;
    }

    //TODO remove this.loading
    if (this.loading) return;
    this.loading = true;
    this.setState({ isPaying: true });

    const payment_method = isWexin ? 'wechat' : 'alipay';
    const payData = genPayData2(form, {
      user_id,
      wallet_id,
      payment_method,
      currency: this.currency()
    });

    if (payment_method === 'wechat') {
      const openId = window.localStorage.getItem('openId');
      if (openId) payData.openId = openId;

      //post (请求1)
      //后端重定向浏览器向微信获取code；微信重定向浏览器传给后台code（请求2）；后台向微信读取openId
      //后端重定向把请求2重定向回前端的url (/pay/wechat_in_app)，并附上所需gateway参数
    }

    api.transaction.init(payData);
  }

  currency = () => {
    //优先取url里的currency
    const { currencyInQuery } = this.state;
    const { currency, orgCurrency } = this.state.data;
    if (
      currencyInQuery &&
      (currencyInQuery === currency ||
        currencyInQuery === orgCurrency ||
        currencyInQuery === 'CNY')
    ) {
      return currencyInQuery;
    }

    return currency;
  };

  render() {
    const { isPayingAlipay, data, isMoneyMore, loadingWallet } = this.state;
    if (isMoneyMore || loadingWallet) {
      return <div />;
    }

    const { rate, charge, accountName } = data;

    const currency = this.currency();

    const { error, isPaying } = this.state;
    let { preset_amount, wallet_id } = this.props.match.params;
    if (parseFloat(preset_amount) > 0) {
      const value = Math.floor(
        numeral(preset_amount)
          .multiply(100)
          .value()
      );
      preset_amount = numeral(value)
        .divide(100)
        .value();

      console.log('preset_amount', preset_amount);
    } else {
      preset_amount = undefined;
    }

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <React.Fragment>
          {!isPayingAlipay && (
            <div>
              <div className="staticqr-form">
                <WalletName style={error ? { color: 'red' } : {}}>
                  {error ? (
                    <FormattedMessage id="staticqr.invalide.account" />
                  ) : (
                    accountName
                  )}
                </WalletName>

                <StaticForm
                  onSubmit={this.onSubmit}
                  rate={rate}
                  charge={charge}
                  preset_amount={preset_amount}
                  currency={currency}
                  isPaying={isPaying}
                  referencePlaceholder={placeholder(wallet_id, this.props)}
                  walletId={wallet_id}
                />
              </div>
              <div ref={ref => (this.form = ref)} />
              <Footer />
            </div>
          )}
        </React.Fragment>
      </IntlProvider>
    );
  }
}

export default StaticQR;



// WEBPACK FOOTER //
// ./src/pages/StaticQR.js